import React, { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie"; // Импортируем js-cookie

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    const storedIsAdmin = Cookies.get("isAdmin");
    if (storedIsAdmin) {
      setIsAdmin(JSON.parse(storedIsAdmin));
    }
  }, []);
  const loginAsAdmin = () => {
    setIsAdmin(true);
    // Сохраняем роль админа в sessionStorage
    Cookies.set("isAdmin", JSON.stringify(true));
  };

  const logout = () => {
    setIsAdmin(false);
    Cookies.remove("isAdmin");
    Cookies.remove("login");
    Cookies.remove("session");
    window.location.replace("/");
    // Удаляем роль админа из sessionStorage
  };

  return (
    <AuthContext.Provider value={{ isAdmin, loginAsAdmin, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => React.useContext(AuthContext);
